module.exports = __webpack_public_path__ + "static/media/om_khare.bba1304f.jpeg";